import * as React from "react";
import Context from "./Context";
import CommentModel from "../models/CommentModel";
import "./CommentReplyButton.styl";

export default class CommentReplyButton extends React.PureComponent<{
    comment: CommentModel;
}> {

    public render(): React.ReactNode {
        const comment = this.props.comment;
        return (
            <Context.Consumer>
                {({translate, dispatch}) => (
                    <div
                        className="Discussion-CommentReplyButton-Root"
                        onClick={() => {
                            dispatch("reply/toggle", comment.getCommentId());
                        }}
                        data-active={comment.getReplyDisplay() ? "1" : "0"}
                    >
                        <div className="Discussion-CommentReplyButton-Icon"/>
                        <div className="Discussion-CommentReplyButton-Label">
                            {translate("REPLY_BUTTON")}
                        </div>
                    </div>
                )}
            </Context.Consumer>
        )
    }

}